import { Component, OnInit, ElementRef, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { TournamentsService } from '~/legacy/ts/tournaments/services/tournaments.service';
import { Observable, Subscription } from 'rxjs';
import { SLIP_WIDTH, TOUCH_NONE } from '~/constant/ui.constant';
import { uiHelper } from '~/helpers/ui.helper';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { CoreService } from '~/legacy/ts/services/core.service';
import { SPORTS_TYPE, sportsTypesChangeListener } from '~/constant/sports.constant';
import { translationHelper } from '~/helpers/translation.helper';

declare let $;
declare let SetLanguage: any;

@Component({
    selector: 'outRightsFixtureView',
    templateUrl: './outRightsFixtureView.html',
})
export class OutRightsFixtureView implements OnInit {
    SLIP_WIDTH: number = SLIP_WIDTH;

    styles = {
        main: { height: this.tournamentsService.Page_Window_Height - 75 + 'px' },
        fixtureArea: {
            width: this.tournamentsService.Page_Window_Width - SLIP_WIDTH - 34 + 'px',
            height: this.tournamentsService.Page_Window_Height - 75 + 'px',
        },
        header: {
            height: '70px',
            'padding-top': '5px',
            'padding-bottom': '5px',
        },
        rows: {
            'background-color': 'rgb(12, 12, 12)',
            height: this.tournamentsService.Page_Window_Height - 255 + 'px',
            'padding-top': '0px',
            'padding-bottom': '0px',
            'overflow-y': 'scroll',
            'padding-right': '0',
            'margin-right': '15px',
        },
        footer: {
            height: '110px',
            'background-color': 'burlywood',
            padding: '0px',
            'touch-action': 'none',
            'user-select': 'none',
        },
        bettingSlip: {
            height: this.tournamentsService.Page_Window_Height - 75 + 'px',
            'padding-top': '0px',
            'padding-left': '5px',
            'padding-right': '0px',
            'padding-bottom': '0px',
            width: SLIP_WIDTH + 'px',
            'margin-left': '15px',
        },
    };

    isLive = false;
    isPre = true;

    constructor(
        public tournamentsService: TournamentsService,
        private _uiHelper: uiHelper,
        private router: Router,
        private coreService: CoreService,
        private _translate: translationHelper,
    ) {
        this.changeState(this.router.url);
        this.router.events.pipe(filter(e => e instanceof NavigationEnd)).subscribe(e => {
            this.changeState(e['url']);
        });
    }

    changeState(e) {
        if (e === '/SportBets') {
            this.isLive = false;
            this.isPre = true;
        } else if (e === '/LiveBets') {
            this.isLive = true;
            this.isPre = false;
        } else if (e === '/' || e === 'index') {
            this.isLive = true;
            this.isPre = false;
        } else {
            // default for error handling
            // console.error('ROUTE ERROR FOR LIVE PRE SELECT');
            this.isLive = true;
            this.isPre = false;
        }
    }

    ngOnInit() {
        this.ClearSlipTimers();
        this.inializeOutrights();
    }

    ClearSlipTimers() {
        this.tournamentsService.SlipNumberControl = 0;
        this.tournamentsService.SlipCashOutSlipPasswordControl = 0;
        this.tournamentsService.cashOutButtonClick = 0;
        this.tournamentsService.payOutButtonClick = 0;
        this.tournamentsService.cashoutMessageTerminalActive = 0;
        this.tournamentsService.cashoutmessageTerminal = '';

        this.coreService.showOpenBetsVisible = 0;
        this.tournamentsService.cleanOpenBets_Timer();
    }

    sportSelected(selectedSportId) {
        this._uiHelper.setSportType(selectedSportId);
    }
    SPORTS_TYPE = SPORTS_TYPE();
    leagueData;
    categoryData;
    private subscriptionsToStopOnDestroy: Subscription[] = [];
    livebets_sporttype_menu_active = 1;
    allLeagues;
    isLeaguesRecevied = false;
    selectAll = {
        name: this._translate.getT('allLeagues'),
        EnumSportType: 0,
        icon: `category-icons/allL.png`,
    };
    getSports() {
        this.subscriptionsToStopOnDestroy.push(
            this.tournamentsService.getSportOutrightsList().subscribe(x => {
                this.categoryData = x.map(x => {
                    return {
                        name: x.SportName,
                        sportEventCount: x.SportEventCount,
                        tName: x.SportName,
                        EnumSportType: x.SportId,
                        icon: `sport-icons/${x.OrginalName}.png`,
                    };
                });
            }),
        );
    }

    getTournamentOutrightsTerminalList(e) {
        this.livebets_sporttype_menu_active = e;

        this.subscriptionsToStopOnDestroy.push(
            this.tournamentsService
                .getTournamentOutrightsTerminalList(this.livebets_sporttype_menu_active)
                .subscribe(x => {
                    if (x && x.length > 0 && x[0].TournamentId) {
                        this.getOutrightEventOddTerminalData(x[0].TournamentId);
                    }
                    this.leagueData = x.map(x => {
                        return {
                            TournamentName: x.TournamentName,
                            sportEventCount: x.SportEventCount,
                            tName: x.SportName,
                            EnumTournamentId: x.TournamentId,
                            icon: `category-icons/${x.Iso}.png`,
                        };
                    });
                }),
        );
    }
    OddsData;
    getOutrightEventOddTerminalData(TournamentId) {
        this.subscriptionsToStopOnDestroy.push(
            this.tournamentsService.getOutrightEventOddTerminalData(TournamentId).subscribe(x => {
                this.OddsData = this.groupEventsByMatchId(x);
            }),
        );
    }

    sportChangeHandler(e) {
        this.getTournamentOutrightsTerminalList(e);
    }
    tournamentSelectHandler(e, item) {
        // this._uiHelper.setTournamentType(e);
        this.getOutrightEventOddTerminalData(item.EnumTournamentId);
    }
    ngOnDestroy(): void {
        for (let subscription of this.subscriptionsToStopOnDestroy) {
            if (subscription) {
                subscription.unsubscribe();
            }
        }
    }

    groupEventsByMatchId(events: any): any[] {
        const groupedEvents: { [key: number]: any } = {};

        events.forEach(event => {
            if (!groupedEvents[event.MatchId]) {
                groupedEvents[event.MatchId] = {
                    EventName: event.EventName,
                    EventStartDate: event.EventStartDate,
                    EventDate: event.EventDate,
                    MatchDate: event.MatchDate,
                    MatchId: event.MatchId,
                    Odds: [],
                    OddTypeCount: event.OddTypeCount,
                    OddValue: event.OddValue,
                    OddsTypeId: event.OddsTypeId,
                    OutCome: event.OutCome,
                    TournamentDate: event.TournamentDate,
                    TournamentId: event.TournamentId,
                };
            }

            groupedEvents[event.MatchId].Odds.push({
                OddId: event.OddId,
                OddValue: event.OddValue,
                OutCome: event.OutCome,
                OddTypeCount: event.OddTypeCount,
                OddsTypeId: event.OddsTypeId,
                TournamentDate: event.TournamentDate,
                TournamentId: event.TournamentId,
                EventName: event.EventName,
                EventStartDate: event.EventStartDate,
                EventDate: event.EventDate,
                MatchDate: event.MatchDate,
                MatchId: event.MatchId,
            });
        });

        return Object.values(groupedEvents);
    }
    inializeOutrights() {
        this.subscriptionsToStopOnDestroy.push(
            this._uiHelper.typeOfListListener.subscribe(item => {
                this.getSports();

                this.sportChangeHandler(1);
            }),
        );
    }
}
